import { ActionTypes } from './constants';

export const setTheme = theme => dispatch => {
    return dispatch({
        type: ActionTypes.SET_THEME,
        payload: theme,
    });
};
